
const MVARange = { min: 0.001, max: 100000000.000 };
const CRange = { min: 0.1, max: 100.0 };

const coolingStageFieldsOptions = {
  nominalPotency: {
    minValue: MVARange.min,
    maxValue: MVARange.max,
    maxLength: 15,
    precision: 3,
    validationLabel: 'asset-information.cooling-stages.validations.nominal-potency',
  },
  oilEnvironmentTopGradient: {
    minValue: CRange.min,
    maxValue: CRange.max,
    maxLength: 5,
    precision: 1,
    validationLabel: 'asset-information.cooling-stages.validations.environment-oil-top-gradient',
  },
  windingGradientHOil: {
    minValue: CRange.min,
    maxValue: CRange.max,
    maxLength: 5,
    precision: 1,
    validationLabel: 'asset-information.cooling-stages.validations.winding-gradient-h-oil',
  },
  windingGradientXOil: {
    minValue: CRange.min,
    maxValue: CRange.max,
    maxLength: 5,
    precision: 1,
    validationLabel: 'asset-information.cooling-stages.validations.winding-gradient-x-oil',
  },
  windingGradientYOil: {
    minValue: CRange.min,
    maxValue: CRange.max,
    maxLength: 5,
    precision: 1,
    validationLabel: 'asset-information.cooling-stages.validations.winding-gradient-y-oil',
  },
};

export default coolingStageFieldsOptions;
